"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../Pages/Dashboard/Types");
var endpoints_1 = require("./endpoints");
var PackIdentifier_1 = require("../Types/PackIdentifier");
var Types_2 = require("../Types");
var Util_1 = require("./Util");
var AuthenticationService_1 = require("./AuthenticationService");
var EventHandlerService_1 = require("./EventHandlerService");
var Exports_1 = require("./Exports");
var GetSinglePackRequestEndpoint = function (selectedAction, manualEntry, result) {
    var _a, _b, _c;
    //console.log(selectedAction);
    var endpoint = endpoints_1.default.Packs.Api.SinglePackRequest + "?isManual=" + manualEntry;
    switch (selectedAction.value) {
        case Types_1.PackAction.Verify.value:
        case Types_1.PackAction.Supply.value:
            //console.log(`adding the following parameters to the endpoint: &action=${selectedAction.value}`);
            endpoint += "&action=" + selectedAction.value;
            break;
        case Types_1.PackAction.ExportFromEU.value:
            endpoint += "&packState=Exported";
        case Types_1.PackAction.MarkAsDestroyed.value:
            endpoint += "&packState=Destroyed";
        case Types_1.PackAction.MarkAsFreeSample.value:
            endpoint += "&packState=FreeSample";
        case Types_1.PackAction.MarkAsLocked.value:
            endpoint += "&packState=Locked";
        case Types_1.PackAction.MarkAsSample.value:
            endpoint += "&packState=Sample";
        case Types_1.PackAction.MarkAsStolen.value:
            endpoint += "&packState=Stolen";
            //console.log(`adding the following parameters to the endpoint: &action=decommission&packState=${selectedAction.value}`);
            endpoint += "&action=decommission";
            break;
        case Types_1.PackAction.Reintroduce.value:
        case Types_1.PackAction.UndoExportFromEU.value:
        case Types_1.PackAction.UndoMarkAsDestroyed.value:
        case Types_1.PackAction.UndoMarkAsFreeSample.value:
        case Types_1.PackAction.UndoMarkAsLocked.value:
        case Types_1.PackAction.UndoMarkAsSample.value:
        case Types_1.PackAction.UndoMarkAsStolen.value:
            //console.log(`adding the following parameters to the endpoint: &action=reactivate&packState=${result?.packInfo?.State?.value}`);
            endpoint += "&action=reactivate&packState=" + ((_c = (_b = (_a = result) === null || _a === void 0 ? void 0 : _a.packInfo) === null || _b === void 0 ? void 0 : _b.State) === null || _c === void 0 ? void 0 : _c.value);
            break;
        default:
            console.warn("Selected pack action unknown: " + selectedAction.value);
    }
    return endpoint;
};
var SinglePackRequestService = /** @class */ (function () {
    function SinglePackRequestService() {
    }
    SinglePackRequestService.SubmitPackRequest = function (packIdentifier, selectedAction, manualEntry, selectedLocation, resources, previousResult) {
        var body = JSON.stringify({
            ProductCodeScheme: PackIdentifier_1.scheme[packIdentifier.scheme],
            ProductCode: packIdentifier.productCode,
            SerialNumber: packIdentifier.serialNumber,
            BatchId: packIdentifier.batchIdentifier,
            ExpiryDate: packIdentifier.expiry
        });
        var endpoint = GetSinglePackRequestEndpoint(selectedAction, manualEntry, previousResult);
        return new Promise(function (resolve, reject) {
            Util_1.postJson(endpoint, body, undefined, undefined, new Util_1.UserRequestHeaders({ Organisation: AuthenticationService_1.Auth.getUser().Organisation, Location: selectedLocation, UserId: AuthenticationService_1.Auth.getUser().id }))
                .then(function (result) {
                if (result != null) {
                    var response = JSON.parse(result);
                    if (response.packInfo.Uprc) {
                        EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_2.UprcWarningEvent(resources, response.packInfo.Uprc));
                    }
                    Exports_1.ScannerBeep.Play(response.ragClass == "Green");
                    resolve(response);
                    //this.setState({
                    //    result: response,
                    //    currentState: SafePageState.Result,
                    //    availableActions: response.packActions
                    //});
                }
                else {
                    reject("No Response");
                    //this.setState({
                    //    currentState: SafePageState.Error,
                    //    availableActions: []
                    //});
                }
            })
                .catch(function (err) {
                return reject(err);
            });
        });
    };
    return SinglePackRequestService;
}());
exports.SinglePackRequestService = SinglePackRequestService;
//# sourceMappingURL=SinglePackRequestService.js.map